export function isconsentGiven() {
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    const decode = (encodedValue) => {
        if (!encodedValue) {
            return;
        }

        return decodeURIComponent(encodedValue.replace(/\+/g, " "))
    };

    const isEuSite = (getCookie('eu-site')) === '1';

    if (!isEuSite) {
        return true;
    }

    const isAllSegmentsAccepted = (() => {
        const cookieSettingsDecoded = decode(getCookie('ha-cookie-settings'));
        const mappedSegments = {};

        if (!cookieSettingsDecoded) {
            return false;
        }

        cookieSettingsDecoded.split(';').forEach(item => {
            const splittedKeyvalue = item.split(':');
            mappedSegments[splittedKeyvalue[0]] = splittedKeyvalue[1] === '1';
        });

        // it gets true only when all the segments gets accepted in the new banner or the user accept the policy in the
        // old banner
        return mappedSegments['functional'];
    })();

    // if its not an eu country, thats mean there is no check for policy
    return isEuSite && isAllSegmentsAccepted;
}
